import { Col, Row } from "antd";
import InputComponent from "../../../components/InputComponent";
import TextareaComponent from "../../../components/TextareaComponent";
import { useBannerContext } from "../../../context/BannerContext/BannerContext";
import { BannerDetailProps, BannerUrlHelperText, BannerBodyConstants, BannerTitleConstants, BannerUrlConstants } from "./constants";

const BannerAddDetail: React.FC<BannerDetailProps> = ({ Culture }) => {
	const { bannerForm, setBannerForm } = useBannerContext();
	const localizable = bannerForm?.bannerLocalizable?.find(item => item.culture === Culture);

	const handleLocalizableChange = (field: string, value: string) => {
		const updatedLocalizable = [...bannerForm.bannerLocalizable];
		const index = updatedLocalizable.findIndex(item => item.culture === Culture);
		if (index !== -1) {
			updatedLocalizable[index] = {
				...updatedLocalizable[index],
				[field]: value
			};
		}
		setBannerForm(prevState => ({
			...prevState,
			bannerLocalizable: updatedLocalizable
		}));
	};

	return (
		<>
			{localizable && (
				<div key={Culture}>
					<Row gutter={20}>
						<Col span={20}>
							<InputComponent
								title={BannerTitleConstants[Culture].title}
								placeholder={BannerTitleConstants[Culture].placeholder}
								value={localizable.header}
								isRequired
								onChange={(e) => handleLocalizableChange("header", e.target.value)}
							/>
						</Col>
					</Row>
					<Row gutter={20}>
						<Col span={20}>
							<TextareaComponent
								title={BannerBodyConstants[Culture].body}
								placeholder={BannerBodyConstants[Culture].placeholder}
								value={localizable.firstHeader}
								resizable={false}
								isRequired
								onChange={(e) => handleLocalizableChange("firstHeader", e.target.value)}
								rows={8}
							/>
						</Col>
					</Row>
					<Row gutter={20} style={{ marginTop: 10 }}>
						{bannerForm.hasNavigation && (
							<Col span={20}>
								<InputComponent
									title={BannerUrlConstants[Culture].url}
									helperText={BannerUrlHelperText}
									placeholder={BannerUrlConstants[Culture].placeholder}
									value={localizable.url}
									onChange={(e) => handleLocalizableChange("url", e.target.value)}
								/>
							</Col>
						)}
					</Row>
				</div>
			)}
		</>
	);
};

export default BannerAddDetail;
